import React, { useContext, useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {
  NavigationRouteProps, MsxExtension, ApplicationContext,
  AttributeProps, NotificationProps
} from '@msx/platform-services'
import { getConfig } from './Extension.config';
import { ExtensionProps, ExtensionTypes } from './Extension.types';
import { shellStyles } from '../../../app/App.styles';
import { ScrollablePane } from '@fluentui/react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Guid, parseQueryString, isEmbeddedInDynamics } from '../../utils';
import { getCurrentAppState } from '../../store';

export const ExtensionComponent: (React.FC<ExtensionProps>) = props => {
  const { componentKey, ignoreWrapControl, searchText,
    suggestionBoxWidth, slimLayout, componentType } = props;
  const { appState } = useContext(ApplicationContext);
  const currentAppState = useSelector(getCurrentAppState);
  const reduxDispatch = useDispatch();
  const [shouldRenderExtension, setShouldRenderExtension] = useState(false);

  useEffect(() => {
    //MOUNT
    if (appState.isReady) {
      setShouldRenderExtension(true);
    }
    // eslint-disable-next-line
  }, []);

  const handleRouteNavigation = (route: NavigationRouteProps) => {
    props.history.push(route.location, searchText);
  }

  const handleLaunchFeedback = (extensionKey: string) => {
    (window as any).startMultiFeedback_AllOptional();
  }

  const handleLaunchChatBot = (extensionKey: string) => {
    (window as any).OpenFDA("hostappid=" + appState.appConfig.botConfig.hostAppId);
  }

  const handleValidateAttributes = (attributes: AttributeProps): boolean => {
    return true;
  }

  const renderExtension = (): JSX.Element => {
    if (!shouldRenderExtension) return null;

    let attributes: { [key: string]: any; } = {};

    // Bellow supplierId and companyCode attributes added for demo purpose
    // only to support Supplier extension. 
    // Please remove those lines during actual implementation
    attributes.supplierId = "0002128831";
    attributes.companyCode = "1010";

    const params = parseQueryString(window.location.search);
    if (params && params.length > 0) {
      const documentNumber = params.find(param => param.key === 'documentNumber');
      if (documentNumber) {
        const hash = Guid.newGuid();
        attributes.hash = hash;
      }
    }

    const config = getConfig();

    return (
      <MsxExtension
        componentKey={componentKey}
        config={config}
        attributes={attributes}
        onNavigateToRoute={handleRouteNavigation}
        onLaunchChatBot={handleLaunchChatBot}
        onLaunchFeedback={handleLaunchFeedback}
        onValidateAttributes={handleValidateAttributes}

      />
    );
  }
  const renderMain = (): JSX.Element => {
    if (ignoreWrapControl) return renderExtension();
    // When embedded in Dynamics the left nav is hidden, so the content pane
    // should span full width (no reserved 48/280px rail).
    const paneClass = isEmbeddedInDynamics()
      ? shellStyles.scrollablePaneEmbedded
      : (currentAppState.isNavCollapsed ? shellStyles.scrollablePaneCollapsed : shellStyles.scrollablePaneExpand);
    return (
      <ScrollablePane className={paneClass}>
        <div className={shellStyles.mainPanelCollapsed}>
          {renderExtension()}
        </div>
      </ScrollablePane>
    );
  }

  return renderMain();

}
export const Extension = withRouter(injectIntl(ExtensionComponent));
